import { render, staticRenderFns } from "./ServiceHistoryWidget.vue?vue&type=template&id=34c85062&scoped=true"
import script from "./ServiceHistoryWidget.vue?vue&type=script&lang=js"
export * from "./ServiceHistoryWidget.vue?vue&type=script&lang=js"
import style0 from "./ServiceHistoryWidget.vue?vue&type=style&index=0&id=34c85062&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c85062",
  null
  
)

export default component.exports